<template>
  <div>
    <b-row class="mt-4">
      <b-col class="col-9">
        <b-button pill
                  v-for="(item,key) in timelines"
                  :key="key"
                  variant="outline-primary"
                  class="m-1"
                  :class="time === key ? 'active' : ''"
                  @click="time = key , changeSelection()">
          {{item}}
        </b-button>
      </b-col>
      <b-col >
        <b-form-group class=" col-2">
          <b-form-radio v-model="cf" name="some-radios" value="MAX" @input="changeSelection()" >Maximum</b-form-radio>
          <b-form-radio v-model="cf" value="AVERAGE" @input="changeSelection()">Mittel</b-form-radio>
          <b-form-checkbox v-model="capacity" @input="changeSelection()">Absolut</b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {VserverGraph} from "@/store/models/vserver/vserver_graph";
  import {PageControl} from "@/store/models/layout/page_control";

  export default {
        name: "luma-time-chart-controller",
        data:()=>({
          cf:'AVERAGE',
          time:null,
          liveIntervall:null,
          capacity:true

        }),
    created(){
      if(!this.time) this.time='hour'
      this.changeSelection(this.time)
      this.graphs.map(el=>{
        VserverGraph.getGraph(this.vid,el[2],el[1])
      })
    },
      computed:{

          vid(){
            return this.$route.params.id
          },
          path(){
            return this.$route.name
          },
          timeC(){
            if(!this.time) return
            //const x = this.time === 'live' && this.models ? this.liveIntervall = setInterval(this.getG,3000)  :  clearInterval(this.liveIntervall)
            return this.time
          },
          timelines(){
            return VserverGraph.timelines()
          },
          graphs(){
            return VserverGraph.modelNames(this.vid).map(el=>el.split('_'))
          },
          models(){
            return VserverGraph.all() || undefined
          }
        },
      methods:{
          getG(){
            //VserverGraph.getGraph(this.vid, 'AVERAGE', 'live')
            //VserverGraph.getGraph(this.vid, 'MAX', 'live')
          },
          changeSelection(){
            const x = Object.assign({},new PageControl)
            x.path= this.path
            x.changes = true
            x.selected = {
              time:this.timeC,
              cf:this.cf,
              capacity:this.capacity
            }
            PageControl.insertOrUpdate({data:x})
            setTimeout(()=> {
              const y = Object.assign({}, new PageControl)
              y.path = this.path
              y.changes = false
              y.selected={
                  time:this.timeC,
                  cf:this.cf,
                  capacity:this.capacity}
              PageControl.insertOrUpdate({data: y})
            },400)

          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/vserver_charts/luma-time-chart-controller.vue